// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { message } from 'antd'
import * as AdminApi from 'api/admin'

export const admin = {
  state: {
    users: [],
    roles: {},
    loading: false,
    modifyLoading: false,
    isEditModalVisible: false,
    editingUser: {
      id: null,
      email: '',
      role_ids: []
    },
    actionType: 'edit'
  },
  reducers: {
    setLoading (state, payload) {
      return {
        ...state,
        loading: payload
      }
    },
    replaceUsers (state, payload) {
      return {
        ...state,
        users: payload.data,
        pagination: {
          pageSize: payload.pageSize,
          total: payload.total,
          current: payload.current
        }
      }
    },
    replaceRoles (state, payload) {
      const obj = {}
      payload.forEach(d => {
        obj[d.id] = d
      })
      return {
        ...state,
        roles: obj
      }
    },

    deleteUserLocal (state, userId) {
      const users = state.users
      const deleteAt = users.findIndex(d => d.id === userId)
      users.splice(deleteAt, 1)
      return {
        ...state,
        users: users.slice()
      }
    },
    modfiyUserLocal (state, user) {
      const users = state.users
      const dataAt = users.findIndex(d => d.id === user.id)
      users.splice(dataAt, 1, user)
      return {
        ...state,
        users: users.slice()
      }
    },
    setPagination (state, payload) {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          current: payload.current,
          pageSize: payload.pageSize
        }
      }
    },
    setModifyLoading (state, payload) {
      return {
        ...state,
        modifyLoading: payload
      }
    },
    setEditModalVisible (state, payload) {
      const newState = {
        ...state,
        isEditModalVisible: payload.visible,
        actionType: payload.actionType || state.actionType
      }
      if (payload.visible === false) {
        newState.editingUser = {
          id: null,
          email: '',
          role_ids: []
        }
      }
      return newState
    },
    setEditingUser (state, user) {
      return {
        ...state,
        editingUser: user
      }
    }
  },
  effects: dispatch => ({
    async fetchUsers (query) {
      this.setLoading(true)
      try {
        const rolesRes = await AdminApi.getRoles()
        if (rolesRes) {
          this.replaceRoles(rolesRes.data.roles)
        }
        const userRes = await AdminApi.getUsers(query)
        if (userRes) {
          this.replaceUsers({
            data: userRes.data.users,
            pagination: {
              total: userRes.data.users.length,
              pageSize: 10,
              current: 1
            }
          })
        }
      } catch (error) {
        message.info(`Fetch Users Fail ${error}`)
      } finally {
        this.setLoading(false)
      }
    },
    async modifyUser (user) {
      this.setModifyLoading(true)
      try {
        await AdminApi.modifyUser({
          user_id: user.id,
          role_ids: user.role_ids
        })
        this.modfiyUserLocal(user)
        message.success('Modify success')
      } catch (error) {
        message.info(`Modify Failed ${error}`)
      } finally {
        this.setModifyLoading(false)
        this.setEditModalVisible({ visible: false })
      }
    },
    async addUser (user) {
      this.setModifyLoading(true)
      try {
        await AdminApi.addUser({
          email: user.email,
          role_ids: user.role_ids
        })
        message.success('Add user success')
        dispatch.admin.fetchUsers({
          page: 1,
          pageSize: 99999
        })
      } catch (error) {
        message.info(`Add user failed ${error}`)
      } finally {
        this.setModifyLoading(false)
        this.setEditModalVisible({ visible: false })
      }
    },
    async deleteUser (userId) {
      try {
        await AdminApi.deleteUser(userId)
        this.deleteUserLocal(userId)
        message.success('Delete success')
      } catch (error) {
        message.info(`Delete Failed ${error}`)
      }
    }
  })
}
